import { useTranslation } from 'react-i18next';

export function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('es') ? 'es' : 'en';
  const toggleLang = () => i18n.changeLanguage(current === 'en' ? 'es' : 'en');
  const linkStyle: React.CSSProperties = {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.8125rem',
    color: 'var(--text-secondary)', textDecoration: 'underline', padding: 0,
  };
  return (
    <div style={{ textAlign: 'right', marginBottom: '0.5rem' }}>
      <button onClick={toggleLang} style={linkStyle}>
        {current === 'en' ? 'Español' : 'English'}
      </button>
    </div>
  );
}
